import React from 'react';
import styles from './index.module.scss';

interface ErrorModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onRetry?: () => void;
  showRetryButton?: boolean;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  title,
  message,
  onClose,
  onRetry,
  showRetryButton = false
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className={styles.content}>
          <p className={styles.message}>{message}</p>
        </div>
        
        <div className={styles.footer}>
          {showRetryButton && onRetry ? (
            <button className={styles.retryButton} onClick={onRetry}>
              Riprova
            </button>
          ) : (
            <button className={styles.closeButton} onClick={onClose}>
              Chiudi
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
